import React from 'react';
import {useSelector} from "react-redux";
import {useData} from "./DataContext";

const PermissionChecker = ({ requiredPermissions, children, ...props }) => {
  const {sharedData} = useData();
  const storedPermissions =  useSelector((state) => state.auth.permissions);
  const permissionList = sharedData.permitted_urls || storedPermissions || [];
  const isSuperuser =  useSelector((state) => state.auth.is_superuser)
  const is_superuser = parseInt(sharedData.is_superuser || "0") || parseInt(isSuperuser || "0") || null;
  if (is_superuser || !requiredPermissions || requiredPermissions.length === 0) {
    return React.Children.map(children, child =>
      React.cloneElement(child, {
        ...props, // Spread all props to children
      })
    );
  } else if (requiredPermissions.length > 0) {
    const hasRequiredPermissions = requiredPermissions.every((permission) =>
      permissionList.includes(permission)
    );

    return hasRequiredPermissions ? (
      React.Children.map(children, child =>
        React.cloneElement(child, {
          ...props, // Spread all props to children
        })
      )
    ) : null;
  }
};

export default PermissionChecker;